import React from 'react'

export  interface ApiData{
    attrName:string
    type:string
    defaultValue:string
    remarks: string
} 

interface ApiTableProps {
    data?:ApiData[]
}

export const DemoApiTable = (props:ApiTableProps) =>{

    return ( <div className='app-demo-api'>
    <table cellPadding="0" cellSpacing="0">
        <colgroup>
            <col width='100px'/>
            <col width='100px'/>
            <col width='200px'/>
            <col />
        </colgroup>
        <tbody>
        <tr className='app-demo-api-table-title'> 
            <td>属性</td>
            <td>类型</td>
            <td>默认值</td>
            <td>说明</td>
        </tr>
        {props.data.map((d:ApiData,index:number)=>{
            return (<tr key={index}>
                <td>{d.attrName}</td>
                <td>{d.type}</td>
                <td>{d.defaultValue}</td>
                <td>{d.remarks}</td>
            </tr>)
        })}
        </tbody>
    </table>
</div>)
}




// WEBPACK FOOTER //
// ./src/demo/components/DemoApiTable.tsx